import BrowserSprite from 'svg-baker-runtime/src/browser-sprite';

const sprite = new BrowserSprite();

document.addEventListener("DOMContentLoaded", function() {
  sprite.mount('#svgSpriteContainer')
});

export default sprite;